export const defaultOperators = {};

export const defaultCombinators = [
  { operand: "and", label: "AND" },
  { operand: "or", label: "OR" },
];

export const defaultLabels = {
  query: {
    delete: {
      ariaLabel: "Reset query",
      tooltip: "Reset query",
      dialogTitle: "Remove all conditions?",
      dialogMessage:
        "Are you sure you want to remove all the conditions? They will be removed permanently.",
      dialogConfirm: "Yes",
      dialogCancel: "No",
      dialogCloseTooltip: "Close",
    },
  },
  rule: {
    attribute: {
      label: "Attribute",
      placeholder: "Select attribute...",
    },
    operator: {
      label: "Operator",
      placeholder: "Select operator...",
    },
    value: {
      distance: {
        label: "Value",
        connectorText: "radius miles from",
        button: "Select location",
        validation: {
          required: "The value is required.",
          invalid: "Value must be a positive number.",
        },
      },
      text: {
        label: "Value",
        placeholder: "Enter value...",
        validation: {
          required: "The value is required.",
        },
      },
      boolean: {
        label: "Value",
        placeholder: "Enter value",
        options: {
          true: "True",
          false: "False",
        },
      },
      numeric: {
        label: "Value",
        placeholder: "Enter value",
        validation: {
          required: "The value is required.",
          invalid: "Value must be a number.",
          equal: "Cannot be equal.",
          greaterThan: "Needs to be greater.",
        },
        range: {
          leftLabel: "From",
          rightLabel: "To",
        },
      },
      datetime: {
        dateLabel: "Date",
        datePlaceholder: "Select Date",
        timeLabel: "Time",
        timePlaceholder: "Select Time",
        startDateLabel: "Start Date",
        startDatePlaceholder: "Select Start Date",
        startTimeLabel: "Start Time",
        startTimePlaceholder: "Select Start Time",
        endDateLabel: "End Date",
        endDatePlaceholder: "Select End Date",
        endTimeLabel: "End Time",
        endTimePlaceholder: "Select End Time",
        validation: {
          required: "The value is required.",
          invalidInterval:
            "End date and time must be after start date and time.",
        },
      },
    },
    delete: {
      ariaLabel: "Remove condition",
      tooltip: "Remove condition",
      dialogTitle: "Remove condition?",
      dialogMessage:
        "Are you sure you want to remove the condition? It will be removed permanently.",
      dialogConfirm: "Yes",
      dialogCancel: "No",
      dialogCloseTooltip: "Close",
    },
  },
  group: {
    delete: {
      ariaLabel: "Remove group",
      tooltip: "Remove group",
      dialogTitle: "Remove group?",
      dialogMessage:
        "Are you sure you want to remove the group? It will be removed permanently.",
      dialogConfirm: "Yes",
      dialogCancel: "No",
      dialogCloseTooltip: "Close",
    },
    reset: {
      ariaLabel: "Change operator",
      tooltip: "Change operator query",
      dialogTitle: "Change conditional operator?",
      dialogMessage:
        "Do you want to change conditional operator? You won't be able to undo this operation. Conditions and/or groups will be removed.",
      dialogConfirm: "Yes",
      dialogCancel: "No",
      dialogCloseTooltip: "Close",
    },
    addRule: {
      label: "Add condition",
    },
    addGroup: {
      label: "Add group",
    },
  },
  empty: {
    title: "No conditions created yet",
    createCondition: "Create a condition",
    createGroup: "condition group",
    spacer: " or a ",
  },
};
